<template>
  <EUIPrimaryLayout :class="containerClass" ref="EUIPriamryLayout">
    <template slot="header">
      <Menu />
      <Header />
    </template>
    <template v-slot:body>
      <Banner v-if="showHeader" />
      <router-view />
    </template>
    <template slot="footer">
      <Footer />
    </template>
  </EUIPrimaryLayout>
</template>
<script>
import EUIPrimaryLayout from '@eui-template/primary-layout';
import Header from '../components/Calculator/Header/Header';
import Menu from '../components/Calculator/Header/Menu';
import Banner from '../components/Calculator/Header/Banner';
import Footer from '../components/Calculator/Footer/Footer';

/**
 * This component defines a common page layout with slots for:
 * - A Header
 * - A Menu
 * - A Footer
 */
export default {
  name: 'CalculatorLayout',
  data() {
    return {};
  },
  methods: {
    getIncludedPathNames(includedPathNames) {
      return includedPathNames.some((path) => path === this.pathName || `${path}/` === this.pathName);
    }
  },
  computed: {
    pathName() {
      return this.$route.path;
    },
    containerClass() {
      return ['/calculator/results', '/calculator/shortlists'].includes(this.$route.path)
        ? 'calculator-container sticky-footer'
        : 'calculator-container';
    },
    showHeader() {
      const pathNames = ['/calculator', '/calculator/thank-you', '/dashboard'];
      return this.getIncludedPathNames(pathNames);
    },
    showFooter() {
      const excludePathNames = ['/calculator', '/calculator/thank-you'];
      return !this.getIncludedPathNames(excludePathNames);
    }
  },
  mounted() {},
  components: {
    EUIPrimaryLayout,
    Header,
    Footer,
    Menu,
    Banner
  }
};
</script>
<style lang="sass" scoped>
.calculator-container
  margin-top: -25px;
</style>
